package horcrux.frontend.common.views.documents.dialogs

import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.views.collections.collectiondialogs.MetadataDetailsDialog
import horcrux.frontend.common.views.documents.DocumentNavigatorMenuOption
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import react.FC
import react.Props

external interface DocumentDetailsDialogProps : Props {
    var showDialogState: BooleanState
    var documentMetadata: DocumentMetadata
}

private val DocumentMetadata.displayString: String
    get() = """Document Name:
        ${documentName.betterToString()}
       
       Document ID: 
        ${this.documentID.betterToString()}
        
       Document URL: 
        ${this.documentURL.betterToString()}
        
       Document Type: 
        ${this.documentType.displayName}        
        
       Created At: 
        ${this.createdAt.toLocalDateTime(TimeZone.UTC)}
        
       Number of Chunks: 
        ${this.numChunks.betterToString()}
    """.trimIndent()

val DocumentDetailsDialog = FC<DocumentDetailsDialogProps> { props ->
    MetadataDetailsDialog {
        this.title = DocumentNavigatorMenuOption.VIEW_DOCUMENT_DETAILS.viewName
        this.detailsText = props.documentMetadata.displayString
        this.showDialogState = props.showDialogState
    }
}
